import React from 'react';
import { X } from 'react-feather';

const Chip = ({children, className, ...props}) => {
  return (
    <div
      className={`rounded bg-primary text-white px-2 text-xs flex items-center cursor-pointer ${className}`}
      {...props}
    >
      <div className="flex-none-bak whitespace-no-wrap">{children}</div>
      <div className="ml-3"><X style={{width: '14px'}}/></div>
    </div>
  )
}

export { Chip }
